const IconArrowRight = (): JSX.Element => {
  return (
    <>
      <path
        clipRule="evenodd"
        d="M5.5,23.3c-.9-.9-.9-2.5,0-3.4l7.9-7.9-7.9-7.9c-.9-.9-.9-2.5,0-3.4.9-.9,2.5-.9,3.4,0l9.6,9.6c.9.9.9,2.5,0,3.4l-9.6,9.6c-.9.9-2.5.9-3.4,0Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  );
};

export default IconArrowRight;
